import { memo } from 'react';

import s from './index.module.scss';

export const AdminMessage = memo(() => {
	return <span className={s.root}>Admin</span>;
});
